  function btnCollectionCartToggle(id) {
    $('#overlay-bg').addClass('overlay-bg-show');
    
    var url = "/cart/add"; // the script where you handle the form input.    
      $.ajax({
             type: "POST",
             url: url,
             data: $("#product-actions-"+id).serialize(), // serializes the form's elements.
             success: function(data)
             {
               	var treeDataString = '';
               	var main_array = ['3ft','4ft','5ft','6ft','7ft','8ft','9ft','10ft','11ft','12ft'];
               $.each( main_array, function( i, val ) {
                        treeDataString += '&attributes['+main_array[i]+']=';
                      });

               removeCartAttributes(treeDataString);
             }
           });
  } 


function removeCartAttributes(treeDataString) {
                    $.ajax({
                           type: "GET",
                           url: '/cart/update.js?attributes[txntype]='+treeDataString+'&attributes[totalTrees]=',
                           success: function(data)
                           {
                             renderSidebarCart();
                           },
                            error: function(XMLHttpRequest, textStatus, errorThrown) {
                              renderSidebarCart();
                            }
                      });
}

function btnQuickCartToggle() {  
  var url = "/cart/add"; // the script where you handle the form input.  
  
  $('#divQuickLoadMessage').html('<p><font color=green><b>Adding product to cart please wait.....</b></font></p>');
  
  $.ajax({
           type: "POST",
           url: url,
           data: $("form[name='frmQuickView']").serialize(), // serializes the form's elements.
           success: function(data)
           {
               var treeDataString = '';
               	var main_array = ['3ft','4ft','5ft','6ft','7ft','8ft','9ft','10ft','11ft','12ft'];
               $.each( main_array, function( i, val ) {
                        treeDataString += '&attributes['+main_array[i]+']=';
                      });

               removeCartAttributes(treeDataString);
               
           }
         });
  
  event.preventDefault();
}


  function renderSidebarCart() { 
    //Before rendering cart check if multiple trees in cart if yes then add/adjust cost of delivery services of extra trees
     adjustMultipleTreeDeliveryCharges(function(){
      adjustMultipleTreeCollectionCharges(function(){
      renderMainSidebarCart();
    });
    }); 
  }
  
  function renderMainSidebarCart() {
    $.ajax({
                       type: "GET",
                       url: '/cart.json',
                       success: function(data)
                       {
                           
                         //Check if extra tree product available
                         var extraDeliveryText = '';
                         var extraDeliveryCost = '';
                         var extraDeliveryId = '';
                         var extraCollectionText = '';
                         var extraCollectionCost = '';
                         var extraCollectionId = '';
                         
                         
                         $.each(data.items, function(i){
                           if(this.product_type == 'Extra Delivery Services') {
                             extraDeliveryText = 'Delivery charges for '+this.quantity+ ' extra tree(s)';
                             
                             extraDeliveryCost = (this.line_price/100);
              				 extraDeliveryCost =  extraDeliveryCost.toFixed(2);
                             
                             extraDeliveryId = this.id;
                             
                           } else if(this.product_type == 'Extra Collection Services') {
                             extraCollectionText = 'Collection charges for '+this.quantity+ ' extra tree(s)';
                             
                             extraCollectionCost = (this.line_price/100);
              				 extraCollectionCost =  extraCollectionCost.toFixed(2);
                             
                             extraCollectionId = this.id;
                           }
                         })
                         
                         var outputText = '';
    
                       // $(".cart-count").text(data.item_count);
                         
                        outputText = '<div class="continue-shoping">'+
                        '<span>My Cart</span>'+
                          '<a href="javascript:void(0);" onclick="closeSidebar();"><i class="cs-font clever-icon-close"></i></a></div>'+
                      '<div class="cart-empty" style="display: none;">'+
                        '<p>You have no items in your shopping cart.</p>'+
                      '</div>';   
                         
                        outputText += '<div class="mini_cart_header" style="display: block;">'+
    								'<ol class="cart-list">';
    
                         
                         $.each(data.items, function(i){
                           if (this.product_type != 'Extra Delivery Services' && this.product_type != 'Extra Collection Services') {
                             if(this.product_type == 'Delivery Services' && extraDeliveryText != '') {
                           		outputText += '<li class="item" id="cart-item-'+this.id+'"><a href="'+this.url+'" title="'+this.product_title+'" class="product-image"><img src="'+this.image+'" alt="'+this.product_title+'"></a><div class="product-inner"><a href="javascript:void(0)" title="Remove Item" class="btn-remove" id="btn-remove-sidebar" onclick="removeFromSidebar('+this.id+','+extraDeliveryId+')"><i class="cs-font clever-icon-close"></i></a><p class="product-name"><a href="'+this.url+'">'+this.product_title+'</a></p><div class="cart-collateral"><span class="price">£'+(this.line_price/100) +' </span> Qty:  '+this.quantity+'<br>'+extraDeliveryText+'<br><p style="margin-top:8px;">£'+extraDeliveryCost+'</p></div></div></li>';
                             } else if(this.product_type == 'Collection Services' && extraCollectionText != '') {
                           		outputText += '<li class="item" id="cart-item-'+this.id+'"><a href="'+this.url+'" title="'+this.product_title+'" class="product-image"><img src="'+this.image+'" alt="'+this.product_title+'"></a><div class="product-inner"><a href="javascript:void(0)" title="Remove Item" class="btn-remove" id="btn-remove-sidebar" onclick="removeFromSidebar('+this.id+','+extraCollectionId+')"><i class="cs-font clever-icon-close"></i></a><p class="product-name"><a href="'+this.url+'">'+this.product_title+'</a></p><div class="cart-collateral"><span class="price">£'+(this.line_price/100) +' </span> Qty:  '+this.quantity+'<br>'+extraCollectionText+'<br><p style="margin-top:8px;">£'+extraCollectionCost+'</p></div></div></li>';
                             } else {
                               outputText += '<li class="item" id="cart-item-'+this.id+'"><a href="'+this.url+'" title="'+this.product_title+'" class="product-image"><img src="'+this.image+'" alt="'+this.product_title+'"></a><div class="product-inner"><a href="javascript:void(0)" title="Remove Item" class="btn-remove" id="btn-remove-sidebar" onclick="removeFromSidebar('+this.id+')"><i class="cs-font clever-icon-close"></i></a><p class="product-name"><a href="'+this.url+'">'+this.product_title+'</a></p><div class="cart-collateral"><span class="price">£'+(this.line_price/100) +' </span> Qty:  '+this.quantity+'</div></div></li>';
                             }
                           }
                         });
                         
                        outputText += '</ol>';  
                         
                        outputText += '<div class="wrap-btcart">'+
      '<div class="summary">'+
        '<p class="total">'+
          '<span class="label" style="color:#000">Total:</span>'+
          '<span class="price">£'+(data.total_price/100)+'</span>'+ 
        '</p>'+
      '</div>'+
      '<div class="actions">'+
        '<div class="view-cart"><a class="harman_btn4" href="/collections/nondrop-christmas-trees"><span>&lt;&lt; Continue</span></a></div>'+
        '<button class="btn harman_btn4" onclick="gotoCart();"><span data-hover="Checkout">Checkout &gt;&gt;</span></button>'+
      '</div>'+
    '</div>'+
  '</div>';
                         $('#dropdown-cart').html(outputText);
                         
                         $(".product-quickview").css("display","none");
               			 $('#dropdown-cart').addClass('active');  
                         $('#overlay-bg').removeClass('overlay-bg-show');
           				}
           });    
   
  }
  
  
  function gotoCart() {
  	location.href="/cart";
  }
  
    
  function removeFromSidebar(id,extraTreeId) {
    extraTreeId = extraTreeId ? extraTreeId : '';
    
      if(extraTreeId > 0) {
        setTimeout(function() {                   
       removeItemFromCart(extraTreeId);
     }, 1000);      
      }

    
      $.ajax({
                         type: "GET",
                         url: '/cart/change?id='+id+'&quantity=0',
                         success: function(data)
                         {                         
                           renderSidebarCart();
                         }
        });
  }

  function closeSidebar() {
  	$('#dropdown-cart').removeClass('active');
 }
  
  
  function removeItemFromCart(id,callback) {
    $.ajax({
                       type: "GET",
                       url: '/cart/change?id='+id+'&quantity=0',
                       success: function(data)
                       {                         
                         if(callback) {
                           callback();
                         }
                       }
      });
  }
  
  
 //Extra delivery chanrges for multiple trees
 function adjustMultipleTreeDeliveryCharges(callback) {
    $.ajax({
        type: "GET",
        url: '/cart.json',
        success: function(data) {
            var totalTrees = 0;
            var deliverCode = '';
            var collectionCode = '';

            var extraDeliverCode = '';
            var extraCollectionCode = '';

            var extraDeliveryId = '';
            var extraCollectionId = '';

          	var currentExtraTreeProducts = 0;
          
            $.each(data.items, function(i) {
                if (this.product_type == 'Nordmann Fir' || this.product_type == 'Norway Spruce' || this.product_type == 'Pot Grown Fraser Fir') {
                    totalTrees = totalTrees + this.quantity;
                } else if (this.product_type == 'Delivery Services') {
                    deliverCode = this.sku;
                } else if (this.product_type == 'Extra Delivery Services') {
                    extraDeliverCode = this.sku;
                    extraDeliveryId = this.id;
                }
              
                if(this.product_type == 'Extra Delivery Services' || this.product_type == 'Extra Collection Services') {
                    currentExtraTreeProducts = currentExtraTreeProducts+this.quantity; 
                }
            });

            $(".cart-count").text(data.item_count-currentExtraTreeProducts);
          

            //If extra trees found in cart
            if (totalTrees > 1) {
                var extraTrees = totalTrees - 1;

                //For Delivery services
                if (deliverCode != '' && extraDeliverCode == '') {
                    // If delivery service is available but extra delivery product not added then add extra delivery product
                    addExtraDeliveryProduct(deliverCode + '-extra', extraTrees,function(){
                      callback();
                    });                  
					
                } else if (deliverCode != '' && extraDeliverCode != '' && extraDeliverCode == deliverCode + '-EXTRA') {
                    // If delivery service is available , extra delivery product is added and matches with delivery service then update it                             
                    if (extraDeliveryId != '') {
                        $.ajax({
                            type: "GET",
                            url: '/cart/change?id=' + extraDeliveryId + '&quantity=' + extraTrees,
                            success: function(data) {
								callback();
							}
                        });
                    }
                } else if (deliverCode != '' && extraDeliverCode != '' && extraDeliverCode != deliverCode + '-EXTRA') {
                    // If delivery service is available , extra delivery product is added but not matching with delivery service then remove it and it new one
                    if (extraDeliveryId != '') {
                      removeItemFromCart(extraDeliveryId,function(){
                      	callback();
                      });                        
                    }
                    
                  	addExtraDeliveryProduct(deliverCode + '-extra', extraTrees,function(){
                      callback();
                    });
                }  else {
                   callback();
                }
            } else {
                if (extraDeliveryId != '') {
                    removeItemFromCart(extraDeliveryId,function(){
                      	callback();
                      });
                } else {
                  callback();
                }
            }                 
        }
    });	
}
  
  //Extra collection chanrges for multiple trees
  function adjustMultipleTreeCollectionCharges(callback) {    
    $.ajax({
                       type: "GET",
                       url: '/cart.json',
                       success: function(data)
                       {
                         
                         var totalTrees = 0;
                         var deliverCode = '';
                         var collectionCode = '';
                         
                         var extraDeliverCode = '';
                         var extraCollectionCode = '';
                         
                         var extraDeliveryId = '';
                         var extraCollectionId = '';
                         
                         $.each(data.items, function(i){                           
                           if(this.product_type == 'Nordmann Fir' || this.product_type == 'Norway Spruce' || this.product_type == 'Pot Grown Fraser Fir') {
                            	totalTrees = totalTrees+this.quantity;
                           } else if(this.product_type == 'Collection Services') {
                            	collectionCode = this.sku;
                           } else if(this.product_type == 'Extra Collection Services') {
                            	extraCollectionCode = this.sku;
                                extraCollectionId = this.id;
                           }                           
                        });
                         
                                              
                         //If extra trees found in cart
                         if(totalTrees > 1) {
                           var extraTrees = totalTrees-1;
                           
                           // For collection services
                             if(collectionCode != '' && extraCollectionCode == '') {
                               addExtraDeliveryProduct(collectionCode+'-extra',extraTrees,function(){
                                callback();
                              });
                             } else if(collectionCode != '' && extraCollectionCode != '' && extraCollectionCode == collectionCode+'-EXTRA') {
                               if(extraCollectionId != '') {
                                   $.ajax({
                                          type: "GET",
                                          url: '/cart/change?id='+extraCollectionId+'&quantity='+extraTrees,
                                          success: function(data)
                                          {
                                            callback();
                                          }
                                  });
                               }
                             }  else if(collectionCode != '' && extraCollectionCode != '' && extraCollectionCode != collectionCode+'-EXTRA') {
                               if(extraCollectionId != '') {
                                   removeItemFromCart(extraCollectionId,function(){
                                    callback();
                                  });
                               }
                               
                               addExtraDeliveryProduct(collectionCode+'-extra',extraTrees,function(){
                                callback();
                              });
                               
                             } else {
                               callback();
                             }
                           
                         } else {
                           if(extraCollectionId != '') { 
                              removeItemFromCart(extraCollectionId,function(){
                                callback();
                              });
                           }
                           callback();
                         }                         
                       }
    });    
  }
  
  
  
  function addExtraDeliveryProduct(code,extraTrees,callback) {
    $.ajax({
           type: "GET",
           url: '/products/'+code+'.json',
      	   success: function(data)
           {
             var firstVariant = data.product.variants[0].id;
            
             if(firstVariant != '') {
               $.ajax({
                                          type: "POST",
                                          url: '/cart/add?quantity='+extraTrees+'&id='+firstVariant,
                                          success: function(data)
                                          {
                                            if(callback) {
                                             callback();
                                           }
                                          }
                                  });              
                            
            }
         }
  });
  }